import { useQuery } from "@apollo/client";
import { Controller, useFormContext } from "react-hook-form";
import Select from "react-select";

import { SKILL_LEVEL_MANY } from "../../../schema/skillLevel";
import { SkillLevel } from "../../../types";
import { Error, Loading } from "../../ui/Alerts";
// import SkillLevelSelect from "./SkillLevelSelect";

const SkillLevelField = () => {
  const {
    formState: { errors },
    control,
  } = useFormContext();

  const { loading, error, data } = useQuery(SKILL_LEVEL_MANY);

  if (loading) return <Loading />;
  if (error) return <Error error={error} />;

  const options = data?.skillLevelMany.map(
    (skillLevel: SkillLevel) =>
      ({
        id: skillLevel._id,
        name: skillLevel.name,
      } as any)
  );

  return (
    <>
      <label
        htmlFor="skill-level-ids"
        className="block text-sm font-medium leading-5 text-gray-900"
      >
        Kompetenzlevel
      </label>
      <Controller
        control={control}
        name="skillLevelIds"
        // render={({ field }) => <SkillLevelSelect {...field} />}
        render={({ field: { onChange, onBlur, value } }) => (
          <Select
            placeholder="Kompetenzlevel wählen..."
            options={options}
            value={options.filter(({ id }: any) => value?.includes(id)) || []}
            getOptionLabel={({ name }: any) => name}
            getOptionValue={({ id }: any) => id}
            isLoading={loading}
            isMulti
            className="basic-multi-select"
            classNamePrefix="select"
            onBlur={onBlur}
            onChange={(values: any) =>
              onChange((values ?? []).map((d: any) => d.id))
            }
          />
        )}
        rules={{ required: false }}
      />
      {errors.skillLevelIds && (
        <span className="text-sm font-light text-red-500">
          Kompetenzlevel fehlt
        </span>
      )}
    </>
  );
};

export default SkillLevelField;
